"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _formik = require("formik");
var R = _interopRequireWildcard(require("ramda"));
var _reactI18next = require("react-i18next");
var _debounce = require("debounce");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Input = _interopRequireDefault(require("../../../ui/Input"));
var _Select = _interopRequireDefault(require("../../../ui/Select"));
var _constants = require("../../store/constants");
var _DatesControl = _interopRequireDefault(require("./components/DatesControl"));
var _StatusControl = _interopRequireDefault(require("./components/StatusControl"));
var _constants2 = require("./constants");
var _helpers = require("./helpers");
var _styles = _interopRequireDefault(require("./styles"));
var _withProps = _interopRequireDefault(require("./withProps"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SearchBasketsForm = function SearchBasketsForm(_ref) {
  var handleSubmit = _ref.handleSubmit,
    submitForm = _ref.submitForm,
    children = _ref.children,
    managersItems = _ref.managersItems;
  var _useTranslation = (0, _reactI18next.useTranslation)('BASKETS_SEARCH_FORM'),
    t = _useTranslation.t;
  var submitFormWithDebounce = (0, _react.useMemo)(function () {
    return (0, _debounce.debounce)(submitForm, 300);
  }, [submitForm]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_formik.FastField, {
    name: _constants2.FORM_FIELDS.STATUS,
    render: function render(_ref2) {
      var field = _ref2.field,
        form = _ref2.form;
      return /*#__PURE__*/_react.default.createElement(_StatusControl.default, {
        activeStatus: field.value,
        onChange: function onChange(status) {
          return Promise.resolve().then(function () {
            return form.setFieldValue(field.name, status);
          }).then(form.submitForm);
        }
      });
    }
  }), /*#__PURE__*/_react.default.createElement("form", {
    action: "#",
    className: _styles.default.root,
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react.default.createElement(_formik.FastField, {
    name: _constants2.FORM_FIELDS.NAME,
    render: function render(_ref3) {
      var field = _ref3.field,
        form = _ref3.form;
      return /*#__PURE__*/_react.default.createElement(_Input.default, _extends({}, field, {
        className: (0, _classnames.default)(_styles.default.col, _styles.default.nameCol),
        label: t('NAME_CONTROL_LABEL'),
        placeholder: t('NAME_CONTROL_PLACEHOLDER'),
        onChange: function onChange(value, event) {
          field.onChange(event);
          Promise.resolve().then(R.thunkify(_helpers.shouldSearchByName)(value)).then(R.when(Boolean, value ? submitFormWithDebounce : submitForm));
        },
        onClear: field.value ? function () {
          return Promise.resolve().then(function () {
            return form.setFieldValue(field.name, '');
          }).then(form.submitForm);
        } : undefined
      }));
    }
  }), /*#__PURE__*/_react.default.createElement(_formik.FastField, {
    name: _constants2.FORM_FIELDS.DATES,
    render: function render(_ref4) {
      var field = _ref4.field,
        form = _ref4.form;
      return /*#__PURE__*/_react.default.createElement(_DatesControl.default, _extends({}, field.value, {
        onChange: function onChange(from, to) {
          return Promise.resolve().then(function () {
            return form.setFieldValue(field.name, {
              from: from,
              to: to
            });
          }).then(form.submitForm);
        }
      }));
    }
  }), /*#__PURE__*/_react.default.createElement(_formik.FastField, {
    name: _constants2.FORM_FIELDS.MANAGER_ID,
    render: function render(_ref5) {
      var field = _ref5.field,
        form = _ref5.form;
      return /*#__PURE__*/_react.default.createElement(_Select.default, {
        className: (0, _classnames.default)(_styles.default.col, _styles.default.managerCol),
        items: managersItems,
        label: t('MANAGER_CONTROL_LABEL'),
        placeholder: t('MANAGER_CONTROL_PLACEHOLDER'),
        value: field.value,
        onChange: function onChange(nextManagerID) {
          return Promise.resolve().then(function () {
            return form.setFieldValue(field.name, nextManagerID);
          }).then(form.submitForm);
        }
      });
    }
  }), /*#__PURE__*/_react.default.createElement(_formik.FastField, {
    name: _constants2.FORM_FIELDS.RECIPIENT,
    render: function render(_ref6) {
      var field = _ref6.field,
        form = _ref6.form;
      return /*#__PURE__*/_react.default.createElement(_Input.default, _extends({}, field, {
        className: (0, _classnames.default)(_styles.default.col, _styles.default.recipientCol),
        label: t('RECIPIENT_CONTROL_LABEL'),
        placeholder: t('RECIPIENT_CONTROL_PLACEHOLDER'),
        onChange: function onChange(value, event) {
          field.onChange(event);
          Promise.resolve().then(R.thunkify(_helpers.shouldSearchByName)(value)).then(R.when(Boolean, value ? submitFormWithDebounce : submitForm));
        },
        onClear: field.value ? function () {
          return Promise.resolve().then(function () {
            return form.setFieldValue(field.name, '');
          }).then(form.submitForm);
        } : undefined
      }));
    }
  })), children);
};
SearchBasketsForm.propTypes = {
  handleSubmit: _propTypes.default.func.isRequired,
  submitForm: _propTypes.default.func.isRequired,
  children: _propTypes.default.node
};
var enhancer = R.compose(_withProps.default, (0, _formik.withFormik)({
  mapPropsToValues: function mapPropsToValues(_ref7) {
    var managersItems = _ref7.managersItems,
      initialPage = _ref7.initialPage;
    return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _constants2.FORM_FIELDS.DATES, {
      from: '',
      to: ''
    }), _constants2.FORM_FIELDS.NAME, ''), _constants2.FORM_FIELDS.MANAGER_ID, R.pipe(R.find(function (_ref8) {
      var initialSelected = _ref8.initialSelected;
      return initialSelected;
    }), R.propOr(null, 'value'))(managersItems)), _constants2.FORM_FIELDS.RECIPIENT, ''), _constants2.FORM_FIELDS.STATUS, _constants.BASKET_STATUSES_MAP.ALL), _constants2.FORM_FIELDS.PAGE, initialPage);
  },
  handleSubmit: function handleSubmit(values, _ref10) {
    var startSearch = _ref10.props.startSearch;
    startSearch(values);
  }
}), _react.memo);
var _default = exports.default = enhancer(SearchBasketsForm);